import React from 'react';
type PriceTagProps = {
  label?: string;
  className?: string;
};
export function PriceTag({
  label = 'Only',
  className = ''
}: PriceTagProps) {
  return <div className={`inline-flex flex-col items-center rounded-lg border border-gold bg-wine px-8 py-4 shadow-luxe ${className}`} data-id="element-212" data-mp="1xknj89jsmotd">
      <span className="text-xs font-bold uppercase tracking-[0.24em] text-champagne" data-id="element-213" data-mp="1oljxsyx5lxbp">
        {label}
      </span>
      <span className="mt-1 font-display text-5xl font-semibold leading-none text-cream sm:text-6xl" data-id="element-214" data-mp="19w4axu0quc1a">
        $26.90
      </span>
      <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-cream/70" data-id="element-215" data-mp="1ep6y9kexgp91">
        USD
      </span>
    </div>;
}